var common = require("../../utiles/common.js")
var service = require("../../utiles/service")
module.exports = {
    register: function () {
        document.createElement('app-manager')
        ko.components.register('app-manager', {
            viewModel: function (params) {
                var $this = this;
                var items = common.fetch("/auth/account/app/list").data;
                var getAppClassification = common.fetch("/auth/account/app/getAppClassification").data;
                var allapp = commonLocal.app.allapp;
                $this.items = items;
                $this.activeList = ko.observableArray();
                $this.categoryActive = ko.observable(allapp);
                $this.classList = ko.observableArray()
                var category = getAppClassification && getAppClassification.appClassJson?JSON.parse(getAppClassification.appClassJson):{}
                category[allapp] = [];
                $this.getCategory = function(category){
                    var categoryList = [allapp];
                    for(var c in category){
                        if(c != allapp){
                            categoryList.push(c);
                        }
                    }
                    return categoryList;
                }
                $this.classList($this.getCategory(category));

                //新增分类
                $this.add = function(){
                    var appCategory = $("#appCategory").val();
                    if($this.classList().length>9){
                        common.message("error",commonLocal.app.categories);
                        return false;
                    }
                    if(!appCategory){
                        common.message("error",commonLocal.app.classificationName);
                        return false;
                    }
                    if($this.classList().indexOf(appCategory)>-1){
                        common.message("error",commonLocal.app.ClassificationAlreadyExists);
                        return false;
                    }else{
                        category[appCategory] = [];
                        console.log(category)
                        $this.classList($this.getCategory(category));
                        $("#appCategory").val("");
                    }
                }
                //删除分类
                $this.remove = function(){
                    common.confirmAlert(commonLocal.app.deleteok,function(){
                        delete category[$this.categoryActive()]
                        $this.classList($this.getCategory(category));
                        $this.categoryActive(allapp);
                        $this.activeList(category[allapp]);
                    })
                }

                $this.selectApp = function(item){
                    if($this.categoryActive() === allapp)return false;
                    var list = $this.activeList();
                    var index = list.indexOf(item.id);
                    if(index>-1){
                        list.splice(index,1);
                    }else{
                        list.push(item.id);
                    }
                    $this.activeList(list);
                }

                $this.selectCategory = function(name){
                    console.log(name)
                    $this.categoryActive(name);
                    $this.activeList(category[name]);
                }

                //提交分类json
                $this.submit = function(){
                    console.log(category)
                    common.fetch("/auth/account/app/appClassification",{
                        type: "POST",
                        data: JSON.stringify({appClassJson:JSON.stringify(category)}),
                        success:function(result){
                            console.log(result)
                           common.confirmAlert(commonLocal.app.saveok,function(){
                               common.redirectTo("/#/appList")
                            })
                        }
                    })
                }

            },
            template: require("./ManagerDetail.html")
        });
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/component/appManager/ManagerDetail.js
// module id = 164
// module chunks = 0